import {
    VMConstants,
    VMsFulfilledConstants,
    VMsPendingConstants,
    VMsRejectedConstants
} from '../actions';

const initialState = {
    items: [],
    total: 0,
    loading: true,
    error: ''
};

export default function (state = initialState, action) {
    switch (action.type) {
        case VMConstants.VMs_CLEARED:
            return initialState;
        case VMsFulfilledConstants.VMs_LOADED:
            return {
                ...initialState,
                items: action.payload.virtualMachines,
                total: action.payload.total,
                loading: false
            };
        case VMsPendingConstants.VMs_LOADED:
            return {
                ...state,
                loading: true
            };
        case VMsFulfilledConstants.VM_UPDATED:
            return {
                ...state,
                loading: false,
                items: state.items.map(item => (item.id === action.payload.id ? action.payload : item))
            };
        case VMsFulfilledConstants.VM_DELETED:
            return { ...initialState, ...state };
        case VMsFulfilledConstants.VM_CREATED:
            return {
                ...state,
                loading: false
            };
        case VMsPendingConstants.VM_UPDATED:
        case VMsPendingConstants.VM_CREATED:
            return {
                ...state,
                loading: true
            };

        case VMsRejectedConstants.VMs_LOADED:
        case VMsRejectedConstants.VM_CREATED:
        case VMsRejectedConstants.VM_UPDATED:
        case VMsRejectedConstants.VM_DELETED: {
            const error = action.payload;

            if (error.response) {
                return {
                    ...state,
                    loading: false,
                    error: `${error.response.data.errorMessage || error.response.status + ' ' + error.response.statusText}`,
                    ...error.response.data
                };
            } else if (error) {
                return {
                    ...state,
                    loading: false,
                    error: error.message
                };
            }

            return state;
        }
        default:
            return state;
    }
}
